import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "webins-riga-riepilogo" }
const _hoisted_2 = ["colspan"]
const _hoisted_3 = {
  key: 0,
  style: {"width":"70px"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("th", { style: {"width":"70px"} }, "Imposte", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("th", { style: {"width":"70px"} }, "Premio", -1)
const _hoisted_6 = {
  key: 1,
  style: {"width":"34px"}
}
const _hoisted_7 = {
  key: 0,
  style: {"width":"50px","padding-left":"0","padding-right":"0"}
}
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "total" }
const _hoisted_17 = ["innerHTML"]

import { ref, computed, onMounted } from "vue";
import { useReservation, useNavigation, useWidget, usePolizze } from "@/composables";
import Popup from "../../popup.vue";
import WebinsService from "@/services/WebinsService";
import { RigaCarrelloDati } from "@/models/RigaCarrello";


export default /*#__PURE__*/_defineComponent({
  props: {
    enableDel: { type: Boolean },
    enableDetailButton: { type: Boolean },
    showMainMedia: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
        enableDel?: boolean;
        enableDetailButton?: boolean;
        showMainMedia?: boolean;
    }





const { getImageThumbPath } = useNavigation();
const { reservation } = useReservation();
const { loading, totali, rigaCarrelloDati, numberToCurrency, getTerminiECondizioni } = usePolizze();
const {  } = useWidget();

const descrizioneCommerceBreve = ref("");
const popup = ref();

var prodotti = ref<RigaCarrelloDati[]>([]); 

prodotti.value.push(rigaCarrelloDati.value);

onMounted( async() => {
    if (!descrizioneCommerceBreve.value)
        descrizioneCommerceBreve.value = await WebinsService.getDescrizioneCommerceBreve(rigaCarrelloDati.value.datiCarrello.pacchettoID);
});

const showDetail = () => {
    popup.value.show();
}

const popupContent = computed( () => {    
    return descrizioneCommerceBreve.value;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("table", _hoisted_1, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("th", {
            colspan: __props.showMainMedia ? 2 : 1
          }, "Polizza", 8, _hoisted_2),
          (_unref(totali) && _unref(totali).scontoCoupon)
            ? (_openBlock(), _createElementBlock("th", _hoisted_3, "Sconto applicato"))
            : _createCommentVNode("", true),
          _hoisted_4,
          _hoisted_5,
          (__props.enableDel == true)
            ? (_openBlock(), _createElementBlock("th", _hoisted_6, " "))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(prodotti), (prod) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: prod.datiProdotto.pacchettoID
          }, [
            (__props.showMainMedia)
              ? (_openBlock(), _createElementBlock("td", _hoisted_7, [
                  (prod.mainMedia)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _unref(getImageThumbPath)(prod.mainMedia.path, 50)
                      }, null, 8, _hoisted_8))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("td", null, [
              _createTextVNode(_toDisplayString(prod.datiProdotto.pacchetto) + " ", 1),
              _hoisted_9,
              _createElementVNode("a", {
                href: "#",
                class: "webins-link",
                style: {"width":"90%","border-radius":"10px"},
                onClick: _withModifiers(($event: any) => (_unref(getTerminiECondizioni)(prod.datiProdotto)), ["prevent"])
              }, " Termini e Condizioni ", 8, _hoisted_10),
              (__props.enableDetailButton)
                ? (_openBlock(), _createElementBlock("br", _hoisted_11))
                : _createCommentVNode("", true),
              (__props.enableDetailButton)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    class: "webins-link",
                    href: "#",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (showDetail()))
                  }, "Vedi dettagli"))
                : _createCommentVNode("", true)
            ]),
            (_unref(totali) && _unref(totali).scontoCoupon)
              ? (_openBlock(), _createElementBlock("td", _hoisted_12, [
                  (_unref(totali))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_unref(numberToCurrency)( String(_unref(totali).scontoCoupon ))), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("td", null, [
              (_unref(totali))
                ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_unref(numberToCurrency)( String(_unref(totali).totaleViaggioImposte ))), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("td", null, [
              (_unref(totali))
                ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_unref(numberToCurrency)( String(_unref(totali).totaleViaggio ))), 1))
                : _createCommentVNode("", true)
            ])
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", null, "Totale " + _toDisplayString(_unref(numberToCurrency)( String(_unref(totali).totaleViaggio ))), 1)
    ]),
    _createVNode(Popup, {
      ref_key: "popup",
      ref: popup
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", { innerHTML: _unref(popupContent) }, null, 8, _hoisted_17)
      ]),
      _: 1
    }, 512)
  ], 64))
}
}

})